<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row m-0 px-xl-5 px-1 py-3 bg-grey">
      <NavbarAccount class="col-md-auto col-12 h-100" />
      <div class="col-md col-sm-12 px-md-2 px-0">
        <div class="bg-white p-1 p-md-5 p-0 shadow-sm container-xl">
          <h4 class="mb-5 pl-3">Mis compras</h4>
          <div class="pl-md-4 pl-0 pb-4">
            <h5 class="text-center text-secondary" v-if="buys.length == 0">
              Aún no tienes compras realizadas.
            </h5>
            <div v-for="buy in buys" :key="buy._id">
              <div class="border rounded shadow-sm p-3 m-2 my-4">
                <div class="row m-0">
                  <div class="col-12">
                    <h3 class="d-md-block d-none">
                      <BadgeStateBuy
                        :state="
                          buy.state.length
                            ? buy.state[buy.state.length - 1].name
                            : 'IN_PREPARATION'
                        "
                      />
                      {{ strToString(buy.creationDate) }}
                    </h3>
                  </div>
                </div>
                <div class="row m-0">
                  <div
                    class="
                      col-md-auto col-12
                      d-flex
                      justify-content-center
                      py-4 py-md-0
                    "
                  >
                    <div
                      class="
                        img-fluid img-thumbnail img-squared
                        d-inline
                        mr-4
                        border
                      "
                      :style="`background-image: url('${getURLImage(
                        buy
                      )}'); min-height: 6em; min-width: 6em;`"
                    ></div>
                  </div>
                  <div class="col">
                    <h6 v-if="buy.products.length">
                      <router-link
                        :to="{
                          name: 'product',
                          params: {
                            id: buy.products[0]._id._id,
                            title: buy.products[0]._id.name.replace(/\s/g, '-'),
                          },
                        }"
                        >{{ buy.products[0]._id.name }}</router-link
                      >
                      {{
                        buy.products.length + buy.services.length > 1
                          ? `(y ${buy.products.length +buy.services.length - 1} productos mas)`
                          : ""
                      }}
                    </h6>
                    <h6 v-else>
                      <router-link
                        :to="{
                          name: 'service',
                          params: {
                            id: buy.services[0]._id._id,
                            title: buy.services[0]._id.name.replace(/\s/g, '-'),
                          },
                        }"
                        >{{ buy.services[0]._id.name }}</router-link
                      >
                      {{
                        buy.services.length + buy.products.length > 1
                          ? `(y ${buy.services.length + buy.products.length - 1} productos mas)`
                          : ""
                      }}
                    </h6>
                    <p>SC${{ (buy.sacoin + buy.financiamiento + buy.otherPayments.reduce((acc, b) =>  acc + b.sacoin+ b.financiamiento, 0)).toFixed(2) }}</p>
                    <h6>
                      <b>Vendedor: {{ buy.seller.username }}</b>
                    </h6>
                  </div>
                  <div class="col-xl-auto col-12 pt-4 pt-xl-0 text-right">
                    <router-link
                      :to="{ name: 'MyPurchase', params: { id: buy._id } }"
                      class="text-decoration-none"
                      ><span class="btn btn-warning"
                        >Ver detalles</span
                      ></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Configs from "@/configs/configs";
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import Api from "../../tools/Api2";
import BadgeStateBuy from "../../components/badges/BadgeStateBuy.vue";
export default {
  name: "MyPurchases",
  components: {
    NavbarMain,
    NavbarAccount,
    BadgeStateBuy,
  },
  data() {
    return {
      buys: [],
      url: Configs.API.BASE,
    };
  },
  methods: {
    getURLImage(buy) {
      if (buy.products.length)
        return (
          this.url + "public/images/products/" + buy.products[0]._id.images[0]
        );

      return (
        this.url + "public/images/services/" + buy.services[0]._id.images[0]
      );
    },
    strToString(str) {
      let date = new Date(str);
      let month = "";
      switch (date.getMonth()) {
        case 0:
          month = "enero";
          break;
        case 1:
          month = "febrero";
          break;
        case 2:
          month = "marzo";
          break;
        case 3:
          month = "abril";
          break;
        case 4:
          month = "mayo";
          break;
        case 5:
          month = "junio";
          break;
        case 6:
          month = "julio";
          break;
        case 7:
          month = "agosto";
          break;
        case 8:
          month = "septiembre";
          break;
        case 9:
          month = "octubre";
          break;
        case 10:
          month = "noviembre";
          break;
        case 11:
          month = "diciembre";
          break;
      }
      return `${date.getDate()} de ${month} del ${date.getFullYear()}`;
    },
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    Api("buy")
      .get("my-purchases")
      .then((res) => {
        this.buys = res.buys;
      });
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}
</style>
